import React from 'react';
import { useSelector } from 'react-redux';
import studentCardImg from '../../../../../../assets/scoreboard/studentCardImg.png';
import ScoreboardHeaderItem from '../../ScoreboardHeaderItem/ScoreboardHeaderItem';

const StudentHeaderItem = ({ item, onClick, onMouseEnter, onMouseLeave, isActive ,number}) => {
  
    const {texts} = useSelector((state) => state.translate);

  return (
    <ScoreboardHeaderItem
      image={studentCardImg}
      number={number?.value ? number?.value : texts[number?.key]}
      textKey={item.textKey}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      isActive={isActive}
    />
  );
};

export default StudentHeaderItem;
